import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconReturn: FC<IconProps> = props => (
    <SVG
        {...props}
        paths={[
            'M853.3504 128l85.2992 170.6496v554.7008c0 23.552-19.0976 42.6496-42.6496 42.6496h-768a42.6496 42.6496 0 0 1-42.6496-42.6496V298.8544L170.6496 128h682.7008z m0 256H170.6496v426.6496h682.7008V384z m-52.736-170.6496H223.3856l-42.5984 85.2992H843.264l-42.6496-85.2992z',
            'M512 768v-128h170.6496v-85.3504H512v-128l-170.7008 170.7008L512 768z'
        ]}
    />
);